import { render } from "./PrescriptionModelOptionsEditor.vue?vue&type=template&id=0ef0273c"
import script from "./PrescriptionModelOptionsEditor.vue?vue&type=script&lang=js"
export * from "./PrescriptionModelOptionsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__